import { render, staticRenderFns } from "./PayrollChangeRequestReasonPicker.vue?vue&type=template&id=6094e892&"
import script from "./PayrollChangeRequestReasonPicker.vue?vue&type=script&lang=ts&"
export * from "./PayrollChangeRequestReasonPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports